(ns common.db.asset-upload.core
  (:require [clojure.string :as str]
            [common.db.effects.http :refer [jsonify]]
            [re-frame.core :as rf]))

(rf/reg-fx :upload/on-change
  (fn [[f url]]
    (f url)))

(rf/reg-fx :upload/abort-submitting
  (fn [[^js controller]]
    (when controller
      (.abort controller))))

(rf/reg-event-fx :upload/change-overlay-state
  (fn [{:keys [db]} [_ path new-state success-message failure-message]]
    {:db (assoc-in db [:upload :meta path] (cond-> {:state new-state}
                                             success-message (assoc :success-message success-message)
                                             failure-message (assoc :failure-message failure-message)))
     :dispatch-later [{:ms 2000 :dispatch [:upload/reset-overlay-state path]}]}))

(rf/reg-event-db :upload/reset-overlay-state
  (fn [db [_ path]]
    (assoc-in db [:upload :meta path] {:state nil})))

(rf/reg-event-fx :upload/upload-asset
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [config context db] :as cofx} [_ path on-change asset]]
    (let [controller (js/AbortController.)
          advertiser-id (js/parseInt (:advertiser-id context))]
      {:db
       (-> db
           (assoc-in [:upload :meta path :requests] controller)
           (assoc-in [:upload :meta path :state] :pending))

       :http
       {:method :post
        :format :form-data
        :uri (str (:apiUrl config) "assets")
        :params {:payload (jsonify {:advertiser-id advertiser-id})
                 :advertiser-id advertiser-id
                 :asset asset}
        :headers {"Authorization" (:resource.user/token cofx)}
        :signal (.-signal controller)
        :on-success [:upload/upload-asset-success path on-change]
        :on-failure [:upload/upload-asset-failure path on-change]}})))

(rf/reg-event-fx :upload/upload-link
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :config)
   (rf/inject-cofx :sub :context)]
  (fn [{:keys [config context db] :as cofx} [_ path on-change asset-url]]
    (let [controller (js/AbortController.)]
      {:db
       (-> db
           (assoc-in [:upload :meta path :requests] controller)
           (assoc-in [:upload :meta path :state] :pending))

       :http
       {:method :post
        :format :json
        :uri (str (:apiUrl config) "assets")
        :params {:advertiser-id (js/parseInt (:advertiser-id context))
                 :url (first (str/split asset-url #"\?"))}
        :headers {"Authorization" (:resource.user/token cofx)}
        :signal (.-signal controller)
        :on-success [:upload/upload-asset-success path on-change]
        :on-failure [:upload/upload-asset-failure path on-change]}})))

(rf/reg-event-fx :upload/upload-asset-success
  (fn [{:keys [db]} [_ path on-change {:keys [url]}]]
    {:upload/on-change [on-change url]
     :db (-> db
             (assoc-in [:upload :meta path] {:state :success
                                             :success-message "Asset uploaded"})
             (update-in [:upload :meta path] dissoc :requests))}))

(rf/reg-event-fx :upload/upload-asset-failure
  (fn [{:keys [db]} [_ path on-change error]]
    (when-not (= "AbortError" (.-name error))
      {:upload/on-change [on-change ""]
       :db (-> db
               (assoc-in [:upload :meta path]
                         {:state :failure
                          :error-message "Upload failed. Please try again"})
               (update-in [:upload :meta path] dissoc :requests))})))

(rf/reg-event-fx :upload/destroy
  (fn [{:keys [db]} [_ path]]
    (let [controller (get-in db [:upload :meta path :requests])]
      {:upload/abort-submitting [controller]
       :db (update-in db [:upload :meta] dissoc path)})))

(rf/reg-sub :upload/state
  (fn [db [_ path]]
    (get-in db [:upload :meta path])))
